export default __webpack_public_path__ + "static/media/slide_04.e4b7dbe3.png";